import {
  onChangeParameter as onChangeParameterOriginal,
  onQuoteRequest
} from 'pu-redux/actions/QuoteActions';

const raiseQuote = (name) =>  name === 'stencil_length_text' || name === 'stencil_width_text';

export const onChangeParameterAndQuote = (name, value, token, variant) => (dispatch, getState) => {
  const _token = token || document.getElementsByName('authenticity_token')[0].value;
  const _variant = variant || document.getElementsByName('variant_id')[0].value;

  onChangeParameterOriginal(name, value)(dispatch);
  const parameters = getState().get('parameters');
  const parametersChanged = getState().get('parametersChanged');

  if (parametersChanged && vfIsValidForQuoteSilent(null, false)) {
    onQuoteRequest(parameters, _token, _variant, parameters.get('product_quote_number'))(dispatch);
  }
};

export const onChangeParameter = (name, value) => (dispatch, getState) => {
  debugger
  const token = document.getElementsByName('authenticity_token')[0].value;
  const variant = document.getElementsByName('variant_id')[0].value;

  onChangeParameterOriginal(name, value)(dispatch);
  const parameters = getState().get('parameters');
  const parametersChanged = getState().get('parametersChanged');

  if (parametersChanged && vfIsValidForQuoteSilent(null, false)) {
    onQuoteRequest(parameters, token, variant, parameters.get('product_quote_number'))(dispatch);
  }
};
